/**
 * Converts an HSV color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes h contained in a set of [0, 360], s and v in a set [0, 100] and
 * returns r, g, and b in the set [0, 255].
 * Taken from https://gist.github.com/mjackson/5311256
 * @param {Number} h - The hue
 * @param {Number} s - The saturation
 * @param {Number} v - The value
 * @return {Object} The RGB representation
 */
const convertHsvToRgb = (h, s, v) => {
    let r, g, b;

    h = h / 360;
    s = s / 100;
    v = v / 100;

    const i = Math.floor(h * 6);
    const f = h * 6 - i;
    const p = v * (1 - s);
    const q = v * (1 - f * s);
    const t = v * (1 - (1 - f) * s);

    /* eslint-disable default-case */
    switch (i % 6) {
        case 0: r = v; g = t; b = p; break;
        case 1: r = q; g = v; b = p; break;
        case 2: r = p; g = v; b = t; break;
        case 3: r = p; g = q; b = v; break;
        case 4: r = t; g = p; b = v; break;
        case 5: r = v; g = p; b = q; break;
    }

    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
};

module.exports = convertHsvToRgb;
